import NewsApi from '@/api/newsApi.js'
import router from '@/router'

const state = {
    newsList: [],
    newsListAndTime: [],
    newsListAndTimeSub: [],
    newsCount: [],
    allPage: 1,
    newsDetail:[],
    newsType: "0",
    currentPage: 1,
    ifShowA: true,
    ifShowB: false,
    loading: false,
}

const getters = {
    time_transfer: state => {
        let list = state.newsList

        let timeTrans = []
        for(let i=0;i<list.length;i++){
            let time = list[i].createTime.substring(0,10)
            timeTrans[i] = {year:time.substring(0,4),
                            month:time.substring(5).replace(/-/,'/')}
        }

        return timeTrans
    },
    time_sub: state => {
        let list = state.newsList

        let timeSub = []
        for(let i=0;i<list.length;i++){
            timeSub[i] = list[i].createTime.substring(0,10)
        }

        return timeSub
    }
    // showing_page_info: state => {
    //     let p = []
    //     for (var i = 1; i <= state.all_page; i++) {
    //         p.push(i)
    //         if (i === 2) {
    //             p.push('...')
    //         } else if (i === state.all_page - 2) {
    //             p.push('... ')
    //         }
    //     }
    //     console.log(p);
    //     return p
    // }
}

const mutations = {

    change_newsList(state,newsList){
        state.newsList = newsList
    },

    change_newsCount(state,newsCount){
        state.newsCount = newsCount
        state.allPage = Math.ceil( newsCount / 5)
    },

    change_newsDetail(state,newsDetail){
        state.newsDetail = newsDetail
    },

    change_newsType(state,newsType){
        state.newsType = newsType
    },

    change_ifShowA(state,ifShowA){
        state.ifShowA = ifShowA
    },

    change_ifShowB(state,ifShowB){
        state.ifShowB = ifShowB
    },

    change_loading(state,loading){
        state.loading = loading
    }

}

const actions = {
    async get_and_change_newsList(context,payload){
        let limit = payload.limit
        let type = payload.type
        let page = payload.page

        // console.log('进actions newsList,',type)
        
        let res = await NewsApi.getNewsList(limit,type,page)
        // console.log('res',res)

        // *** 文件流存储不需要了
        // let reader = new FileReader()

        // for(let i=0;i<res.data.data.length;i++){

        //     let res2 = await NewsApi.getNewsImg(res.data.data[i].newsImg)
        //     reader.readAsDataURL(res2.data)
        //     reader.onload = (e) => {
        //         res.data.data[i].newsImg = e.target.result
        //     }
                
        // }
        // *** 文件流存储不需要了 end

        // console.log(res.data.data)
        // console.log(res.data.count)

        context.commit('change_newsList',res.data.data)
        context.commit('change_newsCount',res.data.count)

    },

    async get_and_change_newsDetail(context,payload){
        let id = payload.id
        let type = payload.type

        document.documentElement.scrollTop = document.body.scrollTop = window.pageYOffset = 0

        let res = await NewsApi.getNewsDetail(id,type)

        // console.log("detail res",res)

        if(res.data.data.beforeDetail == null){
            res.data.data.beforeDetail = {
                newsTitle: "没有了",
                createTime: null
            }
        }
        
        if(res.data.data.nextDetail == null){
            res.data.data.nextDetail = {
                newsTitle: "没有了",
                createTime: null
            }
        }

        context.commit('change_newsDetail',res.data.data)
        

    },

    // 从首页查看新闻详情
    go_detail_from_index(context,payload){
        let id = payload.id
        let type = payload.type
        // ***********  检测首页过来的新闻是不是对应上id  ***********
        // console.log(id)

        context.dispatch('get_and_change_newsDetail',{id:id,type:type}).then(()=>{
            router.replace('/news')
            context.commit('change_ifShowA',false)
            context.commit('change_ifShowB',true)
            context.commit('change_newsType',type)
        })

    },

    // 从新闻页查看新闻详情
    go_detail_from_list(context,payload){
        let id = payload.id
        let type = payload.type

        // console.log('######################################go_detail_from_list','id=',id,'type=',type)

        context.dispatch('get_and_change_newsDetail',{id:id,type:type}).then(() => {
            context.commit('change_ifShowA',false)
            context.commit('change_ifShowB',true)

            // console.log("与下面活的对比，这里输出初始的type",state.newsType)
            
            // 异步的更改慢  但是为了保证刷新时仍能保存newsType 这样created能取到值
            context.commit('change_newsType',type)
            // this.watch((state,getters)=>{
            //     console.log("异步里活的type",state.news.newsType)
            // })
            
        })
        
    },

    // 从首页 查看更多 查看新闻详情
    go_news_from_button(context){
        document.documentElement.scrollTop = document.body.scrollTop = window.pageYOffset = 0
        context.commit('change_ifShowA',true)
        context.commit('change_ifShowB',false)
    }

}

export default{
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}